import { useEffect, useState } from "react";
import { fetchBookExtracts } from "../../api/bookExtracts";
import { Book, UseBookExtractsResult } from "./types";

export function useBookExtracts(query: string): UseBookExtractsResult {
  const [books, setBooks] = useState<Book[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Refetch whenever the (debounced) query changes.
  useEffect(() => {

    // Abort the in-flight request if the query changes or the component
    const controller = new AbortController();

    setIsLoading(true);
    setError(null);

    fetchBookExtracts(query, controller.signal)
      .then((results) => {
        setBooks(results);
        setIsLoading(false);
      })
      .catch((err) => {
        // Ignore abort error as we raise them ourselves.
        if (err.name === "AbortError") {
          return;
        }
        setError("Unable to load book extracts.");
        setIsLoading(false);
      });

    return () => controller.abort();
  }, [query]);

  return { books, isLoading, error };
}
